/**
 * CompetencyBadge — pill-style badge for competency codes
 */

interface CompetencyBadgeProps {
  code: string;
  name?: string;
}

const BADGE_COLORS: Record<string, string> = {
  COM: 'bg-blue-100 text-blue-700 border-blue-200',
  LTW: 'bg-indigo-100 text-indigo-700 border-indigo-200',
  PSD: 'bg-violet-100 text-violet-700 border-violet-200',
  SAW: 'bg-amber-100 text-amber-700 border-amber-200',
  WLM: 'bg-teal-100 text-teal-700 border-teal-200',
  KNO: 'bg-cyan-100 text-cyan-700 border-cyan-200',
  FPA: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  FPM: 'bg-lime-100 text-lime-700 border-lime-200',
  PRO: 'bg-rose-100 text-rose-700 border-rose-200',
  // Operator Competency namespace (G2-02.6): a Tailwind hue unused by the
  // nine reference codes; deliberately not a Brand V3 or PRD Part IV value.
  OPR: 'bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200',
};

const DEFAULT_COLOR = 'bg-gray-100 text-gray-600 border-gray-200';

export default function CompetencyBadge({ code, name }: CompetencyBadgeProps) {
  // Operator codes live in the reserved OPR- namespace (CFX-02); every code
  // in it shares the OPR badge colour.
  const colorKey = code.startsWith('OPR') ? 'OPR' : code;
  const color = BADGE_COLORS[colorKey] ?? DEFAULT_COLOR;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${color}`}
      title={name}
    >
      {code}
    </span>
  );
}
